import * as React from "react";
import { isEqual } from "lodash";

const DEFAULT_PAGE_SIZE = 30;

export type PaginationProps = {
  pagination: {
    offset: number;
    limit: number;
    nextPage: () => void;
    previousPage: () => void;
  };
};

type State = {
  offset: number;
};

const withPagination = <P extends PaginationProps>(
  WrappedComponent: React.ComponentType<P>,
  limit = DEFAULT_PAGE_SIZE
): React.ComponentClass<Omit<P, keyof PaginationProps>> => {
  return class extends React.Component<Omit<P, keyof PaginationProps>, State> {
    static displayName = `withPagination(${WrappedComponent.displayName ||
      WrappedComponent.name})`;

    state = {
      offset: 0
    };

    componentWillReceiveProps(nextProps: P & PaginationProps) {
      if (!isEqual(nextProps, this.props)) {
        this.setState({ offset: 0 });
      }
    }

    render() {
      const { offset } = this.state;
      const pagination = {
        offset,
        limit,
        nextPage: () => {
          this.setState({ offset: offset + limit });
        },
        previousPage: () => {
          this.setState({ offset: Math.max(offset - limit, 0) });
        }
      };

      return (
        <WrappedComponent {...(this.props as any)} pagination={pagination} />
      );
    }
  };
};

export default withPagination;
